export const GET_TEMPLATE_SEGMENTS_COLLABORATORS_WATCHER =
  "app/Segments/GET_TEMPLATE_SEGMENTS_COLLABORATORS_WATCHER"
export const GET_TEMPLATE_SEGMENTS_COLLABORATORS_SUCCESS =
  "app/Segments/GET_TEMPLATE_SEGMENTS_COLLABORATORS_SUCCESS"
export const GET_TEMPLATE_SEGMENTS_COLLABORATORS_FAILED =
  "app/Segments/GET_TEMPLATE_SEGMENTS_COLLABORATORS_FAILED"

export const UPLOAD_TEMPLATE_SEGMENTS_COLLABORATORS_WATCHER =
  "app/Segments/UPLOAD_TEMPLATE_SEGMENTS_COLLABORATORS_WATCHER"
export const UPLOAD_TEMPLATE_SEGMENTS_COLLABORATORS_SUCCESS =
  "app/Segments/UPLOAD_TEMPLATE_SEGMENTS_COLLABORATORS_SUCCESS"
export const UPLOAD_TEMPLATE_SEGMENTS_COLLABORATORS_FAILED =
  "app/Segments/UPLOAD_TEMPLATE_SEGMENTS_COLLABORATORS_FAILED"
export const CLEAR_IMPORT_UPLOAD = "app/Segments/CLEAR_IMPORT_UPLOAD"

export const GET_VARIABLES_WATCHER = "app/Segments/GET_VARIABLES_WATCHER"
export const GET_VARIABLES_SUCCESS = "app/Segments/GET_VARIABLES_SUCCESS"
export const GET_VARIABLES_FAILED = "app/Segments/GET_VARIABLES_FAILED"

export const GET_GROUPS_WATCHER = "app/Segments/GET_GROUPS_WATCHER"
export const GET_GROUPS_SUCCESS = "app/Segments/GET_GROUPS_SUCCESS"
export const GET_GROUPS_FAILED = "app/Segments/GET_GROUPS_FAILED"

export const CREATE_SEGMENT_WATCHER = "app/Segments/CREATE_SEGMENT_WATCHER"
export const CREATE_SEGMENT_SUCCESS = "app/Segments/CREATE_SEGMENT_SUCCESS"
export const CREATE_SEGMENT_FAILED = "app/Segments/CREATE_SEGMENT_FAILED"

export const UPDATE_SEGMENT_WATCHER = "app/Segments/UPDATE_SEGMENT_WATCHER"
export const UPDATE_SEGMENT_SUCCESS = "app/Segments/UPDATE_SEGMENT_SUCCESS"
export const UPDATE_SEGMENT_FAILED = "app/Segments/UPDATE_SEGMENT_FAILED"

export const GET_SEGMENTS_WATCHER = "app/Segments/GET_SEGMENTS_WATCHER"
export const GET_SEGMENTS_SUCCESS = "app/Segments/GET_SEGMENTS_SUCCESS"
export const GET_SEGMENTS_FAILED = "app/Segments/GET_SEGMENTS_FAILED"

export const DELETE_SEGMENT_WATCHER = "app/Segments/DELETE_SEGMENT_WATCHER"
export const DELETE_SEGMENT_SUCCESS = "app/Segments/DELETE_SEGMENT_SUCCESS"
export const DELETE_SEGMENT_FAILED = "app/Segments/DELETE_SEGMENT_FAILED"
